import i18next from 'i18next';
import * as yup from 'yup';

export const yupValidationMessages = () => {
  yup.setLocale({
    mixed: {
      required: i18next.t('validations.required'),
      email: i18next.t('validations.email.invalid'),
      notType: function notType(_ref) {
        switch (_ref.type) {
          case 'number':
            return i18next.t('validations.number.notType');
          case 'date':
            return i18next.t('validations.date.notType');
          default:
            return i18next.t('validations.notType');
        }
      },
    },
    string: {
      email: i18next.t('validations.email.invalid'),
    },
  });
};

export const validateTimeFormat = () => {
  return yup
    .string()
    .nullable()
    .required('validations.required')
    .test('is-valid-time', 'validations.time.invalidFormat', (value) => {
      if (!value) {
        return false;
      }
      return /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/.test(value);
    })
    .transform((value) => (!value ? '' : value));
};
